import { hourglassNotDone } from '@/assets/images/emojis';
import { CallSupportButton } from '@/features/support';
import styles from './DocumentInReview.module.scss';

interface DocumentInReviewProps {
  description: string;
}

// A document the user sent (proof of address, of income) waiting for review.
export function DocumentInReview({ description }: DocumentInReviewProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <img src={hourglassNotDone} alt="" className={styles.emoji} />
        <h1 className={styles.title}>Analiză dosar în procesare</h1>
        <div className={styles.text}>
          <p className={styles.description}>{description}</p>
          <p className={styles.description}>
            În medie, clienții noștri primesc un răspuns în maxim 3 ore.
          </p>
        </div>
      </div>
      <div className={styles.bottomSection}>
        <CallSupportButton />
      </div>
    </div>
  );
}
